const LoadingItem = () => {
  return (
    <div className="loading">
      <h3>Wait a second please. thinking...</h3>
    </div>
  );
};

export default LoadingItem;
